import styled from "styled-components";

export const Container = styled.div`
    overflow: hidden;
   
    h1{
        // text-align: left;
        // margin-bottom: 20px;
        // font-weight: bold;
        // text-transform: uppercase;
        // font-size: 1.8em;
        // letter-spacing: 2px;
        // color: #0d5b5b;
    }

    .carrinhoContainer{
        margin: 1rem auto;
        display: flex;
    }
    .confirmCart{
        background-color: #0d5b5b;
        text-transform: uppercase;
        font-weight: bold;
        color: #fbe777;
        display: flex;
        align-items: center;
        font-size: 1.3em;
        justify-content: center;
        width: 350px;
        height: 50px;
        border-radius: 30px;
        padding: 0px 10px;
        margin: 2rem auto 0px auto;
    }

    .valueCart{
        display: flex;
        justify-content: center;
        width: 100%;
    }
`;
